"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recompose_1 = require("recompose");
const reselect_1 = require("reselect");
const react_redux_1 = require("react-redux");
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = require("./QuestionnaireContext");
const defaultCreateMapStateToProps = (select) => (0, reselect_1.createStructuredSelector)({
    formErrors: select.formErrors,
});
const withFormErrors = (createMapStateToProps = defaultCreateMapStateToProps) => (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)(), (0, react_redux_1.connect)(createMapStateToProps({
    formErrors: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.formErrors()),
    touched: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.touched()),
    hasValidationErrors: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.hasValidationErrors()),
})));
exports.default = withFormErrors;
//# sourceMappingURL=withFormErrors.js.map